<template>
  <div>
      <button @click="$emit('click')" v-bind:class="{ FilterButton: buttonText != 'Create Campaign' , mainAction }" class="speakol-main-button border-transparent outline-none shadow-none text-white cursor-pointer font-medium">
        <slot name="icon"></slot>
        {{ buttonText ? buttonText : "Main Button" }}
      </button>
  </div>
</template>

<script>
export default {
  name: 'speakol-main-button',

  props: {
    buttonText: {
      type: String
    },
    mainAction: {
      type: String
    }
  },

  data () {
    return {}
  }


}
</script>

<style lang="scss">
  .speakol-main-button {
    background-color: #0092d7;
    border-radius: 3px;
    padding: 10px 16px;
    font-size: 14px;

    .create-campaign-icon {
      font-size: 14px !important;
      margin-right: 4px;
    }
  }

  .FilterButton {
    width: 135px;
    height: 40px;
  }

  .mainAction {
    width: 185px;
  }
</style>
